export default {
  title: 'Events',
  actions: {
    create: 'create an event'
  },
  'sentence-action': 'action sentence'
}



// WEBPACK FOOTER //
// ./src/translations/en/events.js